<div role="checkbox" [attr.aria-checked]="selected" [attr.aria-label]="item.name">
    <div class="indicators" [ngClass]="{ 'active': selected }">
        <span class="indicator selected fas fa-check"></span>
        <span class="indicator remove fas fa-remove"></span>
    </div>
    <div class="label-color-box" [style.background-color]="item.color" *ngIf="item.color"></div>
    <div class="label-name">
        @if (!template) {
            {{ item.name }}
        } @else {
            <accessibility-table-filter-selector-item-template [item]="item"></accessibility-table-filter-selector-item-template>
        }
    </div>
</div>
